import { DialogContent, DialogTitle } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import Contact from 'components/@common/Contact';
import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';

interface Props {
  open: boolean;
  onClose: () => void;
}

const ContactDialog = ({ open, onClose }: Props) => {
  return (
    <ResponsiveDrawerDialog isOpen={open} onClose={onClose}>
      <DialogTitle>
        <FormattedMessage id="account.settings.help" />
      </DialogTitle>
      <DialogContent>
        <Contact />
      </DialogContent>
    </ResponsiveDrawerDialog>
  );
};

export default ContactDialog;
